import { render, staticRenderFns } from "./sms-templates-x.vue?vue&type=template&id=59924a5f&scoped=true"
import script from "./sms-templates-x.vue?vue&type=script&lang=js"
export * from "./sms-templates-x.vue?vue&type=script&lang=js"
import style0 from "./sms-templates-x.vue?vue&type=style&index=0&id=59924a5f&prod&lang=scss&scoped=true"
import style1 from "./sms-templates-x.vue?vue&type=style&index=1&id=59924a5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59924a5f",
  null
  
)

export default component.exports